export default "__VITE_PUBLIC_ASSET__7e184cdd__"